/**
 * OrderShimmer — skeleton for order/cart pages while localStorage is being read
 */
const OrderShimmer = () => {
    return (
        <div className="container mx-auto px-4 sm:px-5 mt-5">
            <div className="flex flex-col lg:flex-row gap-3">
                {/* Left panel */}
                <div className="w-full lg:w-1/3 border rounded-md shadow-sm p-5 flex flex-col gap-3">
                    <div className="h-6 w-32 bg-gray-200 rounded animate-pulse" />
                    {Array.from({ length: 5 }).map((_, i) => (
                        <div key={i} className="flex flex-col gap-1">
                            <div className="h-3 w-16 bg-gray-200 rounded animate-pulse" />
                            <div className="h-8 bg-gray-200 rounded-md animate-pulse" />
                        </div>
                    ))}
                </div>

                {/* Right panel */}
                <div className="w-full lg:w-2/3 border rounded-md shadow-sm p-5 flex flex-col gap-4">
                    <div className="h-6 w-32 bg-gray-200 rounded animate-pulse" />
                    {Array.from({ length: 3 }).map((_, i) => (
                        <div key={i} className="flex gap-3 items-center border-b pb-3">
                            <div className="w-16 h-16 bg-gray-200 rounded animate-pulse flex-shrink-0" />
                            <div className="flex flex-col gap-2 flex-1">
                                <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4" />
                                <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2" />
                            </div>
                            <div className="h-5 w-16 bg-gray-200 rounded animate-pulse" />
                        </div>
                    ))}
                    <div className="h-10 bg-gray-200 rounded animate-pulse w-full mt-2" />
                </div>
            </div>
        </div>
    );
};

export default OrderShimmer;
